import { zIndex } from 'common/constants'
import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

interface IStyledDataTableProps {
  maxHeight?: number
  striped?: boolean
}

export const StyledDataTable = styled.div<IStyledDataTableProps>`
  .table-container {
    max-height: ${({ maxHeight }) => `${maxHeight}px`};
  }
  .table {
    color: ${({ theme }) => theme.colors.InfinitiFooterFontColor};
    border-collapse: separate;
    border-spacing: 0;
  }
  ${({ striped, theme }) =>
    striped &&
    `tr.table-row:nth-child(odd) {
        background: ${theme.colors.tableStriped};
    }
    tr.table-row:nth-child(even) {
        background-color: ${theme.colors.inputBackgroundColor};
    }`}
  @media (max-width: ${gridBreakPoints.lg}) {
    overflow: auto;
    scrollbar-width: thin;
  }
`
export const DataTableHeader = styled.div`
  padding-top: 8px;
  padding-bottom: 5px;
  padding-left: 2px;
  padding-right: 2px;
`

export const DataTableCell = styled.div`
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 2px;
  padding-right: 2px;
  position: relative;
  @media (min-width: ${gridBreakPoints.xxl}) {
    font-size: 13px;
  }
`
